
import React , { useState, useRef, useEffect } from 'react'; 
import {AboutDescription,  AboutTeams, AboutTeamsLeft, AboutTeamsRight, AboutTeamsZigZag, BusinessHours} from "./about"
import {HomeIntroduction, HomeIntroductionTwo, HomePhotoGallery, HomeIntroductionThree, HomeQuoteOne, HomeTextGalleryOne, HomeTextGalleryTwo, HomeProductGallery, HomeIntroductionFour, HomeSlider, HomeSocialBanner, HomeFeaturesList, HomeCardList, HomeEventList, HomeBusinessHours, CenterAiBanner, CartList, SponsorsList, TableList} from "./home"
import {TestimonialOne, TestimonialTwo, TestimonialThree} from "./testimonial"
import {WebsiteOne, WebsiteTwo, WebAppConverter, WebAppConverterTwo} from "./website"
import {MapOne} from "./map";
import {ContactOne, ContactProfile, ContactTwo} from "./contact"  
import {ActionWrap} from "./helpers"
import { HeaderAi } from "./header"; 
import { FooterAi } from "./footer"; 
import {VideoOne, VideoTwo} from "./video";
import {FaqOne} from "./faq"
import {ContactFormOne} from "./contactForm"
import app from "./app" 
import {PricingPlan} from "./pricingPlan"
import {TimelineOne, SkillsListOne, ProfileOne, TagsOne} from "./resume"

 

const componentMap = {
    about_us_description: AboutDescription,
    about_us_teams: AboutTeams,
    about_us_teams_left: AboutTeamsLeft,
    about_us_teams_right: AboutTeamsRight,
    about_us_teams_zig_zag: AboutTeamsZigZag,
    business_hours: BusinessHours,
    
    contact_two:ContactTwo,
    contact_profile:ContactProfile,
    contact_one:ContactOne,
    website_one:WebsiteOne,
    map_one:MapOne,
    website_two:WebsiteTwo,
    
    testimonial_one:TestimonialOne,
    testimonial_two:TestimonialTwo,
    testimonial_three:TestimonialThree, //isSwiper

    faq_one: FaqOne,
    pricing_plan: PricingPlan,
    contact_form_one: ContactFormOne,
    timeline_one: TimelineOne,
    skills_list_one: SkillsListOne,
    profile_one: ProfileOne,
    tags_one: TagsOne,

    home_photo_gallery:HomePhotoGallery,
    home_text_gallery:HomeTextGalleryOne,
    home_text_gallery_two:HomeTextGalleryTwo,
    home_introduction_four:HomeIntroductionFour, // isSwiper
    home_introduction:HomeIntroduction, // isSwiper
    home_introduction_three:HomeIntroductionThree, // isSwiper
    home_slider:HomeSlider, // isSwiper 
    home_introduction_two:HomeIntroductionTwo, // isSwiper & isFlipped
    home_quote_one:HomeQuoteOne, // isSwiper & isFlipped
    home_social_banner:HomeSocialBanner, // isSwiper & isFlipped 
    home_product_gallery:HomeProductGallery, // Root Flip
    home_features_list:HomeFeaturesList,  // Root Flip
    home_card_list:HomeCardList, 
    home_event_list:HomeEventList, 
    home_business_hours:HomeBusinessHours, 
    webAppConverter:WebAppConverter,  
    videoOne:VideoOne, 
    videoTwo:VideoTwo, 
    centerAiBanner:CenterAiBanner, 
    webAppConverterTwo:WebAppConverterTwo, 
    cart_list:CartList, 
    sponsors_list:SponsorsList, 
    table_list:TableList, 
    headerAi:HeaderAi, 
    footerAi:FooterAi 
};

export default function Widget(props) {
    const [space, setSpace] = useState([]);

    useEffect(() => {
        if(app.getMode(props.mode)) {
            document.querySelectorAll(".all-widgets .swiper").forEach(function(v){
                let options = {
                    slidesPerView: (props.device === "mobile"?1:v.getAttribute("data-size")),
                    spaceBetween: 30,
                    autoplay: {
                        delay: 3500,
                        disableOnInteraction: false,
                    },
                    pagination: {
                      el: ".swiper-pagination",
                      clickable: true,
                    }
                }
                if(v.getAttribute("data-size") === "1") {
                    options = {
                        pagination: {
                          el: ".swiper-pagination",
                          clickable: true,
                        }
                    }
                }
                new window.Swiper(v, options);
            })
            

        } 
    }, []);
 
    if(props.data.dynamicAIData.length) {   
        let deviceAi = "desktop-ai";
        if(props.device === "mobile"){
            deviceAi = "mobile-ai"
        } 

        let allBlocks =  props.data.dynamicAIData.map(function(v, i){ 
            let lastIndex = false 
            if (i === props.data.dynamicAIData.length - 1) { 
                lastIndex = true
            }
            const WidgetComponent = componentMap[v.widgetType]; 
            if (WidgetComponent) {
                if(v.widgetType !== "headerAi" && v.widgetType !== "footerAi"){
                    return <ActionWrap device={props.device} mode={props.mode} data={v} key={v.viewId} index={i} widgetType={v.widgetType} lastIndex={lastIndex}>
                    <WidgetComponent device={props.device} mode={props.mode} data={v} key={v.viewId} index={i} widgetType={v.widgetType} />
                </ActionWrap> 
                }
            }
            return null;
        })

        allBlocks = allBlocks.filter((v) => {
            if(v === null){
                return false;
            }
            return true;
        });


    return <div className={`all-widgets showAnimation ${props.mode} ${deviceAi}`} style={{paddingTop:space}}>
            {/* {headerAIData} */}
           <style>{
            `
            .showAnimation {
                animation: ani 1s ease forwards;
                position: relative;
                z-index: 1;
              } 
              @keyframes ani {
                0% { 
                  opacity: 0;
                }
                80% { 
                  opacity: 0;
                }
                90% { 
                    opacity:.5;
                    transition:opacity 500ms;
                }
                100% { 
                  opacity: 1; 
                  transition:opacity 500ms;
                }
              }
            `
        }</style> 
        
        {/* {props.header?props.header:null} */}

        { 
            props.data.dynamicAIData.map(function(v, i){ 
                const WidgetComponent = componentMap[v.widgetType]; 
                if (WidgetComponent) {
                    if(v.widgetType === "headerAi"){
                        return <ActionWrap device={props.device} mode={props.mode} key={v.viewId} data={v} index={i} widgetType={v.widgetType}>
                        <WidgetComponent device={props.device} mode={props.mode} key={v.viewId+i} data={v} index={i} widgetType={v.widgetType} headerValue="" cartValue="1" notificationValue="1" appData={props.appData} />
                    </ActionWrap>
                    } 
                }
                return null;
            })
        }

        <div className={`page_body ${app.isHeaderFooter()}`} data-index={allBlocks.length}>
            {allBlocks}
            <div className="position-relative w-100 p-4 text-center block no-block-add" data-index={0}>
                <button className="btn btn-lg btn-outline-dark add-first-section d-block" data-index={0} onClick={function(e){
                    window.actionClick(e)
                }}>
                    Add Section
                </button>
            </div>
        </div>

        { 
            props.data.dynamicAIData.map(function(v, i){ 
                const WidgetComponent = componentMap[v.widgetType]; 
                if (WidgetComponent) {
                    if(v.widgetType === "footerAi"){
                        return <ActionWrap device={props.device} mode={props.mode} key={v.viewId} data={v} index={i} widgetType={v.widgetType}>
                        <WidgetComponent device={props.device} mode={props.mode} key={v.viewId+i} data={v} index={i} widgetType={v.widgetType} headerValue="" cartValue="1" notificationValue="1"/>
                    </ActionWrap>
                    } 
                    return null;
                }
                return null;
            })
        }

    </div>
    }
    if(app.getMode(props.mode)) {
        return null;
    }
    return <div className="w-100 p-4 text-center">
        <button className="btn btn-lg btn-outline-dark add-section" data-index={0} onClick={window.actionClick}>Add Section</button>
    </div>
}